import { Control, FieldValues, Path } from 'react-hook-form'

import { SmartAccountSelectInput } from '~/components/component-library'
import { useDefaultSmartAccount } from '~/hooks/smart-accounts/useDefaultSmartAccount'
import { useTxDisabledSmartAccounts } from '~/hooks/useTransactions'
import { IAddress } from '~/types'

export const SenderSection = <FormType extends FieldValues>({
  control,
  title,
  onSelect,
  senderInputName,
  hideBalance = false,
}: {
  control: Control<FormType>
  title: string
  onSelect?: (value: IAddress) => void
  senderInputName: Path<FormType>
  hideBalance?: boolean
}) => {
  const txDisabledSmartAccounts = useTxDisabledSmartAccounts()
  const [, setDefaultSmartAccountAddress] = useDefaultSmartAccount()

  return (
    <SmartAccountSelectInput<FormType>
      control={control}
      inputName={senderInputName}
      label={title}
      hideBalance={hideBalance}
      setValue={(value: IAddress) => {
        setDefaultSmartAccountAddress(value)
        onSelect?.(value)
      }}
      filteredAddresses={txDisabledSmartAccounts.map(
        (smartAccount) => smartAccount.address,
      )}
      addressLayout="standard"
    />
  )
}
